// provides the decorator metadata vue-property-decorator reads the prop types from
import 'reflect-metadata'
import Vue from './vue'
import VueI18n from 'vue-i18n'

import MessagesProvider from './providers/messages'
import Store from './state/store'
import Router from './router'
import SessionManager from './lib/session_manager'

import ElementUIWrapper from './lib/element_wrapper'
import { AVAILABLE_LOCALES } from '@src/util/constants'

import { Toast } from '@src/elements/toast/toast'

import VueJsonToCsv from 'vue-json-to-csv'

import './sass/main.sass'
import Cookies from '@src/lib/cookies'

const projects = ['app', 'exercises', 'invariants']

let storedLocale = Cookies.get('Locale')
let messagesProvider = new MessagesProvider([storedLocale || 'en-gb'], projects)

messagesProvider.fetchMessages().then(async (messages) => {
  let user = await SessionManager.Instance.restoreUser().catch(() => null)
  let locale = user && user.locale && AVAILABLE_LOCALES.includes(user.locale) ? user.locale : 'en-gb'
  const i18n = new VueI18n({
    locale,
    messages,
    fallbackLocale: 'en-gb'
  })

  let store = new Store(user, i18n)
  let router = new Router(store)

  await ElementUIWrapper.init([locale])
  ElementUIWrapper.locale = locale

  Vue.component('toast', Toast)
  Vue.component('vue-json-to-csv', VueJsonToCsv)

  return new Vue({
    el: '#app',
    router,
    store,
    i18n
  })
}).catch(async (error) => {
  console.error('Failed to initialize app:', error)
  // Fallback: try to boot with default en-gb messages even if cached data is broken
  try {
    const fallbackProvider = new MessagesProvider(['en-gb'], projects)
    const messages = await fallbackProvider.fetchMessages()
    const i18n = new VueI18n({ locale: 'en-gb', messages, fallbackLocale: 'en-gb' })
    let store = new Store(null, i18n)
    let router = new Router(store)
    await ElementUIWrapper.init(['en-gb'])
    ElementUIWrapper.locale = 'en-gb'
    Vue.component('toast', Toast)
    Vue.component('vue-json-to-csv', VueJsonToCsv)
    return new Vue({ el: '#app', router, store, i18n })
  } catch (fallbackErr) {
    // As a last resort, clear only sessionStorage to fix known parse crashes
    try { sessionStorage.clear() } catch (_) {
      console.error('Failed to clear sessionStorage:', _)
    }
    console.error('Fallback init failed:', fallbackErr)
  }
})
